var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "fixed width-100 z-99" },
        [
          _c(
            "van-tabs",
            {
              on: { click: _vm.tableClick },
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            [
              _c("van-tab", { attrs: { title: "全部客户" } }),
              _c("van-tab", { attrs: { title: "我的客户" } }),
            ],
            1
          ),
          _c("van-search", {
            staticClass: "fixed width-99 z-99",
            attrs: { clearable: "", shape: "round", "show-action": "" },
            on: { search: _vm.onSearch },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-110 h-52 l-h-52 bg-FFDA3E b-r-28 text-center",
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.queryParams.companyName,
              callback: function ($$v) {
                _vm.$set(_vm.queryParams, "companyName", $$v)
              },
              expression: "queryParams.companyName",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "h-200" }),
      _c(
        "van-pull-refresh",
        {
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshing,
            callback: function ($$v) {
              _vm.refreshing = $$v
            },
            expression: "refreshing",
          },
        },
        [
          _c(
            "van-list",
            {
              staticClass: "p-l-20 p-r-20 p-b-20",
              attrs: {
                "immediate-check": false,
                error: _vm.error,
                finished: _vm.finished,
                "finished-text": "没有更多了",
              },
              on: {
                "update:error": function ($event) {
                  _vm.error = $event
                },
                load: _vm.getList,
              },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "bg-FF p-30 m-t-20 font-30 font-weight-500",
                },
                [
                  _c("div", { staticClass: "flex" }, [
                    _c("img", {
                      staticClass: "w-50 h-50",
                      attrs: {
                        src: `${_vm.image_base_url}/crm-icon-building.png`,
                        alt: "",
                      },
                    }),
                    _c("p", { staticClass: "m-l-20" }, [
                      _vm._v(_vm._s(item.companyName)),
                    ]),
                  ]),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-30",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "7" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("客户级别"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "17" } }, [
                        _c(
                          "div",
                          { staticClass: "cor-33 font-30" },
                          [
                            _c("dict-tag", {
                              attrs: {
                                options: _vm.customer_level,
                                value: item.companyLevel,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-20",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "7" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("行业"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "17" } }, [
                        _c(
                          "div",
                          { staticClass: "cor-33 font-30" },
                          [
                            _c("dict-tag", {
                              attrs: {
                                options: _vm.customer_nature,
                                value: item.companyNature,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-20",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "7" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("单位类型"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "17" } }, [
                        _c(
                          "div",
                          { staticClass: "cor-33 font-30" },
                          [
                            _c("dict-tag", {
                              attrs: {
                                options: _vm.customer_industry,
                                value: item.companyIndustry,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "van-row",
                    {
                      staticClass: "m-t-20",
                      attrs: { type: "flex", align: "center" },
                    },
                    [
                      _c("van-col", { attrs: { span: "7" } }, [
                        _c("div", { staticClass: "cor-88 font-30" }, [
                          _vm._v("客户规模"),
                        ]),
                      ]),
                      _c("van-col", { attrs: { span: "17" } }, [
                        _c(
                          "div",
                          { staticClass: "cor-33 font-30" },
                          [
                            _c("dict-tag", {
                              attrs: {
                                options: _vm.custom_base,
                                value: item.customBase,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("van-divider"),
                  _c(
                    "van-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "van-col",
                        {
                          staticStyle: { "border-right": "1px solid #EBEBEB" },
                          attrs: { span: 8 },
                          on: {
                            click: function ($event) {
                              return _vm.addVisit(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "flex" }, [
                            _c("img", {
                              staticClass: "w-36 h-36",
                              attrs: {
                                src: `${_vm.image_base_url}/crm-icon-add.png`,
                              },
                            }),
                            _c(
                              "p",
                              { staticClass: "font-28 font-weight-500 p-l-10" },
                              [_vm._v("拜访记录")]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "van-col",
                        {
                          staticStyle: { "border-right": "1px solid #EBEBEB" },
                          attrs: { span: 8 },
                          on: {
                            click: function ($event) {
                              return _vm.addCustomer(item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "flex row-center" }, [
                            _c("img", {
                              staticClass: "w-36 h-36",
                              attrs: {
                                src: `${_vm.image_base_url}/crm-icon-add.png`,
                              },
                            }),
                            _c(
                              "p",
                              { staticClass: "font-28 font-weight-500 p-l-10" },
                              [_vm._v("联系人")]
                            ),
                          ]),
                        ]
                      ),
                      _c("van-col", { attrs: { span: 8 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex row-center",
                            on: {
                              click: function ($event) {
                                return _vm.details(item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "w-36 h-36",
                              attrs: {
                                src: `${_vm.image_base_url}/crm-icon-view.png`,
                              },
                            }),
                            _c(
                              "p",
                              { staticClass: "font-28 font-weight-500 p-l-10" },
                              [_vm._v("详情")]
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "zjm-fixed-bottom pos-b-140 pos-r-20 bg-FFDB43 cor-00 font-50",
          on: { click: _vm.onAddClick },
        },
        [_vm._v("+")]
      ),
      _c(
        "div",
        {
          staticClass:
            "zjm-fixed-bottom pos-b-20 pos-r-20 bg-FFDB43 cor-FF font-28",
          on: { click: _vm.goBack },
        },
        [_vm._v("返回")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }